import { forwardRef, memo, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
// Material UI imports
import Tab, { type TabProps } from '@mui/material/Tab';

type TabParamLinkProps = Omit<TabProps, 'onClick'> & {
  readonly tabParam: string;
  readonly paramValue: string;
};

const TabParamLink = forwardRef<HTMLDivElement, TabParamLinkProps>(({
  tabParam,
  paramValue,
  ...props
}, ref) => {
  const [, setSearchParams] = useSearchParams();

  const handleClick = useCallback(() => {
    setSearchParams(prev => {
      const next = new URLSearchParams(prev);
      next.set(tabParam, paramValue);
      return next;
    });
  }, [tabParam, paramValue, setSearchParams]);

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Tab ref={ref} onClick={handleClick} {...props}/>;
});

TabParamLink.displayName = 'TabParamLink';

export default memo(TabParamLink);
